// Live Routes
export const ROUTE_LOGIN = "/login";
export const ROUTE_SIGN_UP = "/sign-up";
export const ROUTE_REGISTER = "/register";

export const ROUTE_APP = "/";
export const ROUTE_HOME = "/home";

export const ROUTE_DASHBOARD = "/dashboard";

export const ROUTE_SETTINGS = "/settings";
export const ROUTE_SETTINGS_CONTACT = "/settings/contact";
export const ROUTE_SETTINGS_FINANCIAL = "/settings/financial";
export const ROUTE_SETTINGS_ACCOUNT = "/settings/account";

export const ROUTE_ONBOARDING = "/onboarding";
export const ROUTE_ONBOARDING_PLANS = "/onboarding/plans";
export const ROUTE_ONBOARDING_CONTACT = "/onboarding/contact";
export const ROUTE_ONBOARDING_FINANCIAL = "/onboarding/financial";
export const ROUTE_ONBOARDING_ANNUITY = "/onboarding/annuity";
export const ROUTE_ONBOARDING_SUMMARY = "/onboarding/summary";

export const ROUTE_FORGOT_PASSWORD = "/forgot-password";
export const ROUTE_RESET_PASSWORD = "/reset-password";

// Enroll
// export const ROUTE_ENROLL = "/enroll";
// export const ROUTE_ENROLL_PLANS = "/enroll/plans";
// export const ROUTE_ENROLL_CONTACT = "/enroll/contact";
// export const ROUTE_ENROLL_FINANCIAL = "/enroll/financial";
// export const ROUTE_ENROLL_ANNUITY = "/enroll/annuity";
// export const ROUTE_ENROLL_SUMMARY = "/enroll/summary";

// NOT LIVE ROUTES
// export const ROUTE_START = "/start";
// export const ROUTE_START_CREATE_ACCOUNT = "/start/create-account";
// export const ROUTE_START_TFA_SETUP = "/start/tfa";

// export const ROUTE_ACCOUNT = "/account";
// export const ROUTE_ACCOUNT_TYPE = "/account/type";
// export const ROUTE_ACCOUNT_RETIREMENT = "/account/retirement";
// export const ROUTE_ACCOUNT_PLAN = "/account/plan";
// export const ROUTE_ACCOUNT_SUBSCRIPTION = "/account/subscription";
// export const ROUTE_ACCOUNT_CONFIRM = "/account/confirm";
// export const ROUTE_ACCOUNT_SUCCESS = "/account/success";

// export const ROUTE_ACCOUNT_FUND = "/account/fund";

// export const ROUTE_DEPOSIT = "/deposit/:accountId";

// export const ROUTE_RECURRING_DEPOSIT = "/recurring-deposit/:accountId";

// export const ROUTE_ACCOUNTS = "/accounts";
// export const ROUTE_ACCOUNTS_DETAILS = "/accounts/:accountId";

// export const ROUTE_TRANSACTIONS = "/transactions";

export const ROUTE_CALCULATOR = "/calculator";

export const ROUTE_STYLES = "/styles";

